type WeekInfo = Readonly<{ firstDay: number }>

type LocaleWithWeekInfo = Intl.Locale & {
  getWeekInfo?: () => WeekInfo
  weekInfo?: WeekInfo
}

function getBrowserLocale(): string {
  return new Intl.DateTimeFormat().resolvedOptions().locale
}

export function getGuestHourCycle(): 12 | 24 {
  const { hourCycle } = new Intl.DateTimeFormat(getBrowserLocale(), {
    hour: 'numeric',
  }).resolvedOptions()
  return hourCycle === 'h11' || hourCycle === 'h12' ? 12 : 24
}

export function getGuestWeekStartsOn(): 0 | 1 {
  const locale: LocaleWithWeekInfo = new Intl.Locale(getBrowserLocale())
  const firstDay = (locale.getWeekInfo?.() ?? locale.weekInfo)?.firstDay
  if (firstDay === undefined) return 1
  return firstDay === 1 ? 1 : 0
}
